import { __assign } from "tslib";
import { getHighContrastNoAdjustStyle, HighContrastSelector, memoizeFunction } from '@fluentui/react';
/** Inner border is most easily achieved with :after CSS selector. The selector itself is defined by the caller and this
 * function just returns the styles (IStyle) necessary
 */
export var getInnerBorderStyles = memoizeFunction(function (borderSettings) {
    var _a;
    var gap = borderSettings.gap || 0;
    var gapStyles = {
        top: gap,
        left: gap,
        right: gap,
        bottom: gap,
    };
    return __assign(__assign({ content: '""', position: 'absolute', borderWidth: borderSettings.width, borderStyle: borderSettings.style || 'solid', borderColor: borderSettings.color, pointerEvents: 'none' }, gapStyles), { selectors: (_a = {},
            _a[HighContrastSelector] = __assign({ borderColor: 'HighlightText' }, getHighContrastNoAdjustStyle()),
            _a) });
});
//# sourceMappingURL=getInnerBorderStyles.js.map